export default __webpack_public_path__ + "static/media/2098.46b047cf.png";